import React from 'react';
import {
  BarChart3,
  TrendingUp,
  PieChart,
  Activity,
  AlertCircle,
  Clock,
} from 'lucide-react';
import SectionHeader from '../ui/SectionHeader';

const AnalyticsPage = () => {
  return (
    <div className="animate-stagger">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-text-primary mb-2">Analytics</h1>
        <p className="text-text-secondary">
          Herramientas de análisis de negocio y métricas
        </p>
      </div>

      {/* Coming Soon Banner */}
      <section className="section">
        <div className="card p-12 text-center border-2 border-dashed border-primary/30 bg-primary-lighter/10">
          <div className="w-20 h-20 rounded-full bg-primary-lighter/50 flex items-center justify-center mx-auto mb-6">
            <BarChart3 size={40} className="text-primary" />
          </div>
          <h2 className="text-2xl font-bold text-text-primary mb-3">
            Próximamente
          </h2>
          <p className="text-text-secondary max-w-md mx-auto mb-6">
            Estamos preparando un conjunto de herramientas de análisis para que puedas 
            visualizar métricas de negocio, rendimiento y tendencias.
          </p>
          <div className="flex items-center justify-center gap-2 text-primary">
            <Clock size={18} />
            <span className="font-medium">En desarrollo</span>
          </div>
        </div>
      </section>

      {/* Planned Features */}
      <section className="section">
        <SectionHeader
          title="Funcionalidades Planificadas"
          description="Lo que podrás hacer cuando esté disponible"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div id="dashboard-ventas" className="card p-6 opacity-75 scroll-mt-24">
            <div className="w-12 h-12 rounded-xl bg-info/10 flex items-center justify-center mb-4">
              <TrendingUp size={24} className="text-info" />
            </div>
            <h3 className="font-semibold text-text-primary mb-2">Dashboard de Ventas</h3>
            <p className="text-text-secondary text-sm">
              Visualización de métricas comerciales, pipeline y conversiones en tiempo real.
            </p>
          </div>

          <div id="reportes-personalizados" className="card p-6 opacity-75 scroll-mt-24">
            <div className="w-12 h-12 rounded-xl bg-success/10 flex items-center justify-center mb-4">
              <PieChart size={24} className="text-success" />
            </div>
            <h3 className="font-semibold text-text-primary mb-2">Reportes Personalizados</h3>
            <p className="text-text-secondary text-sm">
              Genera reportes adaptados a tus necesidades con filtros avanzados.
            </p>
          </div>

          <div id="metricas-rendimiento" className="card p-6 opacity-75 scroll-mt-24">
            <div className="w-12 h-12 rounded-xl bg-warning/10 flex items-center justify-center mb-4">
              <Activity size={24} className="text-warning" />
            </div>
            <h3 className="font-semibold text-text-primary mb-2">Métricas de Rendimiento</h3>
            <p className="text-text-secondary text-sm">
              KPIs y objetivos para seguimiento del rendimiento individual y de equipo.
            </p>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="mt-8 p-6 bg-info/5 rounded-2xl border border-info/20">
        <div className="flex items-start gap-4">
          <AlertCircle size={24} className="text-info flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-semibold text-text-primary mb-2">
              ¿Necesitas acceder a datos específicos?
            </h3>
            <p className="text-text-secondary text-sm">
              Mientras desarrollamos esta sección, puedes acceder a reportes y análisis a través 
              de Salesforce o contactar con el equipo de operaciones para solicitar informes 
              personalizados.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnalyticsPage;


